import { Pipe, PipeTransform } from '@angular/core'
import { getName, NameCapableObject } from '@seiri/shared/common'

@Pipe({
  name: 'getName',
})
export class GetNamePipe implements PipeTransform {
  transform(user?: NameCapableObject | null, emailFallback = true, emptyChar = '-'): string {
    const name = getName(user, { emailFallback })
    if (!name) {
      return emptyChar
    }
    return name
  }
}
